import { useContext } from 'react';
import { LocalVideoTrack, Participant, RemoteVideoTrack } from 'livekit-client';
import { FullscreenContext, FullscreenContextOptions } from 'contexts';
import { FullscreenButton, StageFooter } from 'features/Room/components';
import { ScreenShare } from 'features/ScreenShare';
import { useDoubleClick } from 'ui/hooks/useDoubleClick';
import { useVideoQualityByParticipantCount } from 'hooks/useVideoQualityByParticipantCount';
import { useShowOnMovingPointer } from 'ui/hooks/useShowOnMovingPointer';
import { StageProps } from '../types';
import { FooterLayout, MainLayout, SidebarLayout, StageLayout } from './view';
import { ParticipantsList } from './components/ParticipantsList/ParticipantsList';

type ScreenShareStageProps = StageProps & {
    participants: Participant[];
    screenTrack: LocalVideoTrack | RemoteVideoTrack;
};

export const ScreenShareStage = ({
    roomState,
    controlRenderer,
    onLeave,
    participants,
    screenTrack,
}: ScreenShareStageProps) => {
    const { setFullscreenActive } = useContext<FullscreenContextOptions>(FullscreenContext);

    const ref = useDoubleClick<HTMLDivElement>({
        callback: setFullscreenActive,
    });
    const { isInterfaceHidden } = useShowOnMovingPointer({ ref });

    useVideoQualityByParticipantCount();

    return (
        <StageLayout>
            <MainLayout ref={ref}>
                <ScreenShare track={screenTrack} isAuthorShown />
                <FullscreenButton onClick={setFullscreenActive} isHidden={isInterfaceHidden} />
            </MainLayout>
            <SidebarLayout>
                <ParticipantsList participants={participants} room={roomState.room} />
            </SidebarLayout>
            <FooterLayout>
                <StageFooter
                    roomState={roomState}
                    controlRenderer={controlRenderer}
                    onLeave={onLeave}
                    participants={participants}
                />
            </FooterLayout>
        </StageLayout>
    );
};
